module.exports = __webpack_public_path__ + "img/metal_g@2x.02fd0f73.png";